var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignalCellularGood(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.75 3.33334H16.25V16.6667H13.75V3.33334ZM3.75 11.6667H6.25V16.6667H3.75V11.6667ZM8.75 7.50001H11.25V16.6667H8.75V7.50001Z",
    fill: "#2ECC71"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignalCellularGood);
export default __webpack_public_path__ + "static/media/signal-cellular-good.6230ff4e5ac89162071b78dedb93a958.svg";
export { ForwardRef as ReactComponent };